<template>
  <section class="relative">
    <div class="max-w-[1920px] p-4 md:px-[60px] lg:px-8 xl:px-[80px] 2xl:px-[120px] mx-auto">
      <div class="hidden md:block w-[340px] h-[340px] left-[-180px] top-[160px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="md:hidden w-[150px] h-[150px] left-[0px] top-[60px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="hidden md:block w-[340px] h-[340px] left-[-20px] top-[300px] rounded-full bg-blue-100 absolute z-0" />
      <div class="md:hidden w-[150px] h-[150px] left-[-50px] top-[60px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="hidden md:block w-[340px] h-[340px] left-[-180px] top-[450px] rounded-full bg-blue-100 absolute z-0" />
      <div class="md:hidden w-[150px] h-[150px] left-[-30px] top-[160px] rounded-full bg-blue-100 absolute z-0 " />

      <div class="hidden md:block w-[206px] h-[206px] right-[-100px] top-[100px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="hidden md:block w-[206px] h-[206px] right-[60px] top-[100px] rounded-full bg-blue-100 absolute z-0" />
      <div class="hidden md:block w-[317px] h-[317px] right-[-25px] top-[140px] rounded-full bg-blue-100 absolute z-0" />
      <div class="md:hidden w-[150px] h-[150px] right-[-50px] top-[500px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="md:hidden w-[150px] h-[150px] right-[0px] top-[560px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="md:hidden w-[150px] h-[150px] right-[-50px] top-[600px] rounded-full bg-blue-100 absolute z-0 " />

      <div class="hidden md:block w-[340px] h-[340px] right-[220px] bottom-[-300px] rounded-full bg-blue-100 absolute z-0" />
      <div class="hidden md:block w-[340px] h-[340px] right-[425px] bottom-[-220px] rounded-full bg-blue-100 absolute z-0" />
      <div class="hidden md:block w-[340px] h-[340px] right-[555px] bottom-[-350px] rounded-full bg-blue-100 absolute z-0" />
      <div class="md:hidden w-[150px] h-[150px] left-[0px] bottom-[-60px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="md:hidden w-[150px] h-[150px] left-[-50px] bottom-[10px] rounded-full bg-blue-100 absolute z-0 " />
      <div class="md:hidden w-[150px] h-[150px] left-[50px] bottom-[10px] rounded-full bg-blue-100 absolute z-0 " />

      <div class="flex flex-col lg:flex-row mt-[80px] xl:my-[140px] justify-between items-center lg:space-x-[40px] 2xl:space-x-[200px] z-10 relative">
        <div class="text-left my-[60px]">
          <h2 class="text-[40px] lg:text-[55px] xl:text-[74px] font-bold text-blue-500 leading-none pb-3">{{ t('home.products.title') }}</h2>
          <h3 class="text-[20px] md:text-[32px] font-bold text-black leading-none mb-8 md:mb-10">
            {{ t('home.products.subtitle') }}
          </h3>
          <p class="text-[18px] md:text-[22px] font-[400] mb-6">
            {{ t('home.products.intro') }}
          </p>
          <p class="text-[18px] md:text-[22px] font-[400] mb-8 md:mb-10">
            <ul>
              <li>{{ t('home.products.item1') }}</li>
              <li>{{ t('home.products.item2') }}</li>
              <li>{{ t('home.products.item3') }}</li>
              <li>{{ t('home.products.item4') }}</li>
            </ul>
          </p>
          <VaButton
            :to="{ name: 'products' }"
            color="pink-500"
            round
          >
            <span class="py-2 px-14 text-[16px] lg:text-[20px] xl:text-[22px]">{{ t('home.products.learnMore') }}</span>
          </VaButton>
        </div>
        <div class="z-10 pb-[60px] lg:p-0 w-[350px] lg:w-[500px] 2xl:w-[680px] flex-shrink-0 flex-grow-0">
          <img src="@/assets/images/frame.png " alt="frame" class="hidden lg:block">
          <img src="@/assets/images/frame-mobile.png" alt="frame" class="block lg:hidden">
        </div>
      </div>

      <div class="mb-20 z-10 relative">
        <div class="text-left z-10 flex flex-col md:flex-row items-start md:items-end space-x-0 md:space-x-10 justify-between">
          <p class="text-[24px] lg:text[27px] xl:text-[30px] 2xl:text-[40px] uppercase text-gray-100 font-bold 2xl:leading-none max-w-[1118px] pb-8 md:pb-0">
            {{ t('home.products.contact1') }}
            <br>
            <span class="text-blue-500">{{ t('home.products.contact2') }}</span>
          </p>
          <VaButton :to="{ name: 'contact' }">
            <span class="py-2 px-[34px] text-[16px] lg:text-[20px] xl:text-[22px] whitespace-nowrap">{{ t('home.products.contactButton') }}</span>
          </VaButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
